import { HistoricHand, HandHistoryList } from '../../communication/PlayerApiProtocol.generated'
import {assign, ReduxAction} from '../ReduxUtils'
import {SessionGroup, HandHistoryUtils} from '../../ui/profilepage/gameplay-history/hand-history/HandHistoryUtils'
import {
	RECEIVE_HAND_HISTORY, REQUEST_HAND_HISTORY, PAGE_COUNT, SELECT_HAND, SELECT_HAND_DETAIL,
	SelectHandAction, RECEIVE_HAND_HISTORY_ERROR, SHOW_ALL_HANDS, CLEAR_TABLE_SESSION, CLEAR_ALL, REQUEST_PREVIOUS_PAGE,
	REQUEST_NEXT_PAGE, CLEAR_PREVIOUS_PAGES, SelectHandDetailAction,
} from './HandHistoryActions'
import {Action} from 'redux'

export interface HandHistoryRequest {
    descending : boolean,
    startTime : number,
    nextHandIndex : number,
    nextSessionIndex : number,
    tableIntegrationId : string
}
export interface  HandHistoryState {
    previousPages?: number[],
    sessions?: SessionGroup[],
    session?: SessionGroup,
    hasNextPage?: boolean;
    hasNextHand?: boolean;
    hasPreviousPage?: boolean;
    hasPreviousHand?: boolean;
    startTime?: number,
    hands?: HistoricHand[],
    activeHand?: any,
    activeHandDetail?: HistoricHand,
    activeHandIndex?: number,
    loading?: boolean,
    error?: boolean,
    sessionIndex?: number,
    updating?: boolean;
    currentPageSum?: number;
    tableIntegrationId?: string;
    firstHandStartTime?: number;
    lastHandStartTime?: number;
    requestCount?: number;
    descending?: boolean;
    handIndex?: number;
    latestHandStartTime?: number;
    oldestHandStartTime?: number;
}


const initialState : HandHistoryState  =  {
	startTime : 0,
	sessions : null,
	session : null,
	sessionIndex : 0,
	hands : null,
	activeHand : null,
	activeHandDetail : null,
	activeHandIndex : null,
	loading : false,
	error : false,
	currentPageSum : 0,
	tableIntegrationId : null,
	firstHandStartTime : 0,
	lastHandStartTime : 0,
	requestCount : 0,
	previousPages : []
}

/**
 * Profile reducer, managing PlayerProfileState part of the application state
 * @param state
 * @param action
 * @returns {PlayerProfileState}
 */
export function historyReducer(state : HandHistoryState = initialState, anAction : Action ) : HandHistoryState {
	var action : ReduxAction<any> = anAction as ReduxAction<any>

	switch (action.type) {
	case CLEAR_PREVIOUS_PAGES:
		return assign<HandHistoryState>({}, state, {
			previousPages : [],
			startTime : 0
		})
	case CLEAR_TABLE_SESSION:
		return assign<HandHistoryState>({}, state, {
			activeHand : null,
		})
	case SHOW_ALL_HANDS:
		return assign<HandHistoryState>({}, state, {
			activeHand : null,
			activeHandIndex : null,
			sessionIndex: null
		})
	case SELECT_HAND:
		let payload : SelectHandAction = action.payload
		var hasNextPage = state.currentPageSum == PAGE_COUNT
		return assign<HandHistoryState>({}, state, {
			activeHand : payload.activeHand,
			activeHandIndex : payload.activeHandIndex,
			sessionIndex: payload.sessionIndex,
			hasNextPage :  hasNextPage,
			hasPreviousPage : state.previousPages.length > 0,
			hasPreviousHand : hasPreviousHand(payload.activeHandIndex, payload.sessionIndex, state),
			hasNextHand : !(HandHistoryUtils.isLastHandInCurrentSession(payload.sessionIndex, payload.activeHandIndex,state.sessions) &&
                    HandHistoryUtils.isLastLoadedSession(payload.sessionIndex, state.sessions) && !hasNextPage)
		})
	case SELECT_HAND_DETAIL:
		let handDetailPayload : SelectHandDetailAction = action.payload
		return assign<HandHistoryState>({}, state, {
			activeHandDetail : handDetailPayload.activeHandDetail,
		})
	case RECEIVE_HAND_HISTORY_ERROR:
		return assign<HandHistoryState>({}, state, {
			error : true,
			loading : false
		})
	case REQUEST_HAND_HISTORY:
		let request : HandHistoryRequest = action.payload
		let nextHandIndex = request.nextHandIndex
		let nextSessionIndex = request.nextSessionIndex

		return assign<HandHistoryState>({}, state, {
			updating: true,
			startTime: request.startTime,
			descending: request.descending,
			activeHandIndex: nextHandIndex,
			sessionIndex: nextSessionIndex,
			tableIntegrationId : request.tableIntegrationId
		})
	case REQUEST_NEXT_PAGE:
		let previousPages = state.previousPages
		if ((action.payload != 0) &&
                !(state.previousPages.length > 0 && state.previousPages[state.previousPages.length-1] == action.payload)
		) {
			previousPages = state.previousPages.concat([action.payload])
		}
		return assign<HandHistoryState>({}, state, {
			previousPages : previousPages
		})
	case REQUEST_PREVIOUS_PAGE:
		let pages = state.previousPages.slice(0, -1)
            
		return assign<HandHistoryState>({}, state, {
			previousPages : pages
		})
	case RECEIVE_HAND_HISTORY:
		return handleHandHistory(state,action.payload)
	case CLEAR_ALL:
		return initialState
	default:
		return state                                  
	}
}

function handleHandHistory(state : HandHistoryState, history : HandHistoryList) : HandHistoryState {
	let startTime = state.startTime
	let descending = state.descending
	var requestCount = state.requestCount + 1
	if (state.startTime == 0) {
		requestCount = 1
	}
	var hands = history.hands
	if (state.descending == false) {
		hands = HandHistoryUtils.reverseOrder(hands)
	}
	let currentPageSum = hands.length

	let firstHandStartTime = 0
	let lastHandStartTime = 0

	var groups = HandHistoryUtils.toHandSessions({hands : hands})

	if (descending  == false || startTime == 0) {
		if (hands.length > 0) {
			startTime =  groups[0].hands[0].startTime
		} else {
			startTime = Date.now()
		}
	}

	if (hands.length > 0) {
		firstHandStartTime = hands[0].startTime
		lastHandStartTime = hands[hands.length-1].startTime
	}
	let handIndex = state.activeHandIndex
    
	let sessionIndex = state.sessionIndex
	let activeHand = null
	if (typeof(handIndex) !== 'undefined') {
		if (handIndex == Number.MAX_VALUE) {
			handIndex =  groups[groups.length-1].hands.length-1
			sessionIndex = groups.length-1
		}
		activeHand = groups[sessionIndex].hands[handIndex]
	} else {
		handIndex = 0
		sessionIndex = 0
	}

	var hasNextPage = lastHandStartTime > history.oldestHandStartTime
	var newerHandsExist = firstHandStartTime < history.latestHandStartTime
	return assign<HandHistoryState>({}, state, {
		startTime: startTime,
		currentPageSum: currentPageSum,
		sessions: groups,
		tableIntegrationId: state.tableIntegrationId,
		loading: false,
		updating: false,
		activeHandIndex: handIndex,
		sessionIndex: sessionIndex,
		activeHand: activeHand,
		firstHandStartTime: firstHandStartTime,
		lastHandStartTime: lastHandStartTime,
		requestCount : requestCount,
		hasNextPage :  hasNextPage,
		hasPreviousPage : newerHandsExist,
		hasPreviousHand : hasPreviousHand(handIndex, sessionIndex, state),
		hasNextHand : !(HandHistoryUtils.isLastHandInCurrentSession(sessionIndex, handIndex,groups) &&
            HandHistoryUtils.isLastLoadedSession(sessionIndex, groups) && !hasNextPage),
		latestHandStartTime : history.latestHandStartTime,
		oldestHandStartTime : history.oldestHandStartTime
	})
}


function hasPreviousHand(handIndex: number, sessionIndex: number, state: HandHistoryState): boolean {
	return !(HandHistoryUtils.isFirstHandInSession(handIndex) &&
        HandHistoryUtils.isFirstSessionLoaded(sessionIndex) &&
        HandHistoryUtils.isFirstPage(state.previousPages))
}


